/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/@shopify/theme-product-form/listeners.js":
/*!***************************************************************!*\
  !*** ./node_modules/@shopify/theme-product-form/listeners.js ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Listeners)
/* harmony export */ });
function Listeners() {
  this.entries = [];
}

Listeners.prototype.add = function(element, event, fn) {
  this.entries.push({ element: element, event: event, fn: fn });
  element.addEventListener(event, fn);
};

Listeners.prototype.removeAll = function() {
  this.entries = this.entries.filter(function(listener) {
    listener.element.removeEventListener(listener.event, listener.fn);
    return false;
  });
};


/***/ }),

/***/ "./node_modules/@shopify/theme-product-form/theme-product-form.js":
/*!************************************************************************!*\
  !*** ./node_modules/@shopify/theme-product-form/theme-product-form.js ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getUrlWithVariant": () => (/* binding */ getUrlWithVariant),
/* harmony export */   "ProductForm": () => (/* binding */ ProductForm)
/* harmony export */ });
/* harmony import */ var _listeners__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./listeners */ "./node_modules/@shopify/theme-product-form/listeners.js");
/* harmony import */ var _shopify_theme_product__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @shopify/theme-product */ "./node_modules/@shopify/theme-product/theme-product.js");



var selectors = {
  idInput: '[name="id"]',
  optionInput: '[name^="options"]',
  quantityInput: '[name="quantity"]',
  propertyInput: '[name^="properties"]'
};

// Public Methods
// -----------------------------------------------------------------------------

/**
 * Returns a URL with a variant ID query parameter. Useful for updating window.history
 * with a new URL based on the currently select product variant.
 * @param {string} url - The URL you wish to append the variant ID to
 * @param {number} id  - The variant ID you wish to append to the URL
 * @returns {string} - The new url which includes the variant ID query parameter
 */

function getUrlWithVariant(url, id) {
  if (/variant=/.test(url)) {
    return url.replace(/(variant=)[^&]+/, '$1' + id);
  } else if (/\?/.test(url)) {
    return url.concat('&variant=').concat(id);
  }

  return url.concat('?variant=').concat(id);
}

/**
 * Constructor class that creates a new instance of a product form controller.
 *
 * @param {Element} element - DOM element which is equal to the <form> node wrapping product form inputs
 * @param {Object} product - A product object
 * @param {Object} options - Optional options object
 * @param {Function} options.onOptionChange - Callback for whenever an option input changes
 * @param {Function} options.onQuantityChange - Callback for whenever an quantity input changes
 * @param {Function} options.onPropertyChange - Callback for whenever a property input changes
 * @param {Function} options.onFormSubmit - Callback for whenever the product form is submitted
 */
function ProductForm(element, product, options) {
  this.element = element;
  this.product = _validateProductObject(product);

  options = options || {};

  this._listeners = new _listeners__WEBPACK_IMPORTED_MODULE_0__["default"]();
  this._listeners.add(
    this.element,
    'submit',
    this._onSubmit.bind(this, options)
  );

  this.optionInputs = this._initInputs(
    selectors.optionInput,
    options.onOptionChange
  );

  this.quantityInputs = this._initInputs(
    selectors.quantityInput,
    options.onQuantityChange
  );

  this.propertyInputs = this._initInputs(
    selectors.propertyInput,
    options.onPropertyChange
  );
}

/**
 * Cleans up all event handlers that were assigned when the Product Form was constructed.
 * Useful for use when a section needs to be reloaded in the theme editor.
 */
ProductForm.prototype.destroy = function() {
  this._listeners.removeAll();
};

/**
 * Getter method which returns the array of currently selected option values
 *
 * @returns {Array} An array of option values
 */
ProductForm.prototype.options = function() {
  return _serializeOptionValues(this.optionInputs, function(item) {
    var regex = /(?:^(options\[))(.*?)(?:\])/;
    item.name = regex.exec(item.name)[2]; // Use just the value between 'options[' and ']'
    return item;
  });
};

/**
 * Getter method which returns the currently selected variant, or `null` if variant
 * doesn't exist.
 *
 * @returns {Object|null} Variant object
 */
ProductForm.prototype.variant = function() {
  return (0,_shopify_theme_product__WEBPACK_IMPORTED_MODULE_1__.getVariantFromSerializedArray)(this.product, this.options());
};

/**
 * Getter method which returns a collection of objects containing name and values
 * of property inputs
 *
 * @returns {Array} Collection of objects with name and value keys
 */
ProductForm.prototype.properties = function() {
  var properties = _serializePropertyValues(this.propertyInputs, function(
    propertyName
  ) {
    var regex = /(?:^(properties\[))(.*?)(?:\])/;
    var name = regex.exec(propertyName)[2]; // Use just the value between 'properties[' and ']'
    return name;
  });

  return Object.entries(properties).length === 0 ? null : properties;
};

/**
 * Getter method which returns the current quantity or 1 if no quantity input is
 * included in the form
 *
 * @returns {Array} Collection of objects with name and value keys
 */
ProductForm.prototype.quantity = function() {
  return this.quantityInputs[0]
    ? Number.parseInt(this.quantityInputs[0].value, 10)
    : 1;
};

// Private Methods
// -----------------------------------------------------------------------------
ProductForm.prototype._setIdInputValue = function(value) {
  var idInputElement = this.element.querySelector(selectors.idInput);

  if (!idInputElement) {
    idInputElement = document.createElement('input');
    idInputElement.type = 'hidden';
    idInputElement.name = 'id';
    this.element.appendChild(idInputElement);
  }

  idInputElement.value = value.toString();
};

ProductForm.prototype._onSubmit = function(options, event) {
  event.dataset = this._getProductFormEventData();

  if (event.dataset.variant) {
    this._setIdInputValue(event.dataset.variant.id);
  }

  if (options.onFormSubmit) {
    options.onFormSubmit(event);
  }
};

ProductForm.prototype._onFormEvent = function(cb) {
  if (typeof cb === 'undefined') {
    return Function.prototype;
  }

  return function(event) {
    event.dataset = this._getProductFormEventData();
    cb(event);
  }.bind(this);
};

ProductForm.prototype._initInputs = function(selector, cb) {
  var elements = Array.prototype.slice.call(
    this.element.querySelectorAll(selector)
  );

  return elements.map(
    function(element) {
      this._listeners.add(element, 'change', this._onFormEvent(cb));
      return element;
    }.bind(this)
  );
};

ProductForm.prototype._getProductFormEventData = function() {
  return {
    options: this.options(),
    variant: this.variant(),
    properties: this.properties(),
    quantity: this.quantity()
  };
};

function _serializeOptionValues(inputs, transform) {
  return inputs.reduce(function(options, input) {
    if (
      input.checked || // If input is a checked (means type radio or checkbox)
      (input.type !== 'radio' && input.type !== 'checkbox') // Or if its any other type of input
    ) {
      options.push(transform({ name: input.name, value: input.value }));
    }

    return options;
  }, []);
}

function _serializePropertyValues(inputs, transform) {
  return inputs.reduce(function(properties, input) {
    if (
      input.checked || // If input is a checked (means type radio or checkbox)
      (input.type !== 'radio' && input.type !== 'checkbox') // Or if its any other type of input
    ) {
      properties[transform(input.name)] = input.value;
    }

    return properties;
  }, {});
}

function _validateProductObject(product) {
  if (typeof product !== 'object') {
    throw new TypeError(product + ' is not an object.');
  }

  if (typeof product.variants[0].options === 'undefined') {
    throw new TypeError(
      'Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route'
    );
  }

  return product;
}


/***/ }),

/***/ "./node_modules/@shopify/theme-product/theme-product.js":
/*!**************************************************************!*\
  !*** ./node_modules/@shopify/theme-product/theme-product.js ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getProductJson": () => (/* binding */ getProductJson),
/* harmony export */   "getVariantFromId": () => (/* binding */ getVariantFromId),
/* harmony export */   "getVariantFromSerializedArray": () => (/* binding */ getVariantFromSerializedArray),
/* harmony export */   "getVariantFromOptionArray": () => (/* binding */ getVariantFromOptionArray)
/* harmony export */ });
/**
 * Returns a product JSON object when passed a product URL
 * @param {*} url
 */
function getProductJson(handle) {
  return fetch('/products/' + handle + '.js').then(function(response) {
    return response.json();
  });
}

/**
 * Find a match in the project JSON (using a ID number) and return the variant (as an Object)
 * @param {Object} product Product JSON object
 * @param {Number} value Accepts Number (e.g. 6908023078973)
 * @returns {Object} The variant object once a match has been successful. Otherwise null will be return
 */
function getVariantFromId(product, value) {
  _validateProductStructure(product);

  if (typeof value !== 'number') {
    throw new TypeError(value + ' is not a Number.');
  }

  var result = product.variants.filter(function(variant) {
    return variant.id === value;
  });

  return result[0] || null;
}

/**
 * Convert the Object (with 'name' and 'value' keys) into an Array of values, then find a match & return the variant (as an Object)
 * @param {Object} product Product JSON object
 * @param {Object} collection Object with 'name' and 'value' keys (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
 * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
 */
function getVariantFromSerializedArray(product, collection) {
  _validateProductStructure(product);

  // If value is an array of options
  var optionArray = _createOptionArrayFromOptionCollection(product, collection);
  return getVariantFromOptionArray(product, optionArray);
}

/**
 * Find a match in the project JSON (using Array with option values) and return the variant (as an Object)
 * @param {Object} product Product JSON object
 * @param {Array} options List of submitted values (e.g. ['36', 'Black'])
 * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
 */
function getVariantFromOptionArray(product, options) {
  _validateProductStructure(product);
  _validateOptionsArray(options);

  var result = product.variants.filter(function(variant) {
    return options.every(function(option, index) {
      return variant.options[index] === option;
    });
  });

  return result[0] || null;
}

/**
 * Creates an array of selected options from the object
 * Loops through the project.options and check if the "option name" exist (product.options.name) and matches the target
 * @param {Object} product Product JSON object
 * @param {Array} collection Array of object (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
 * @returns {Array} The result of the matched values. (e.g. ['36', 'Black'])
 */
function _createOptionArrayFromOptionCollection(product, collection) {
  _validateProductStructure(product);
  _validateSerializedArray(collection);

  var optionArray = [];

  collection.forEach(function(option) {
    for (var i = 0; i < product.options.length; i++) {
      if (product.options[i].name.toLowerCase() === option.name.toLowerCase()) {
        optionArray[i] = option.value;
        break;
      }
    }
  });

  return optionArray;
}

/**
 * Check if the product data is a valid JS object
 * Error will be thrown if type is invalid
 * @param {object} product Product JSON object
 */
function _validateProductStructure(product) {
  if (typeof product !== 'object') {
    throw new TypeError(product + ' is not an object.');
  }

  if (Object.keys(product).length === 0 && product.constructor === Object) {
    throw new Error(product + ' is empty.');
  }
}

/**
 * Validate the structure of the array
 * It must be formatted like jQuery's serializeArray()
 * @param {Array} collection Array of object [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }]
 */
function _validateSerializedArray(collection) {
  if (!Array.isArray(collection)) {
    throw new TypeError(collection + ' is not an array.');
  }

  if (collection.length === 0) {
    return [];
  }

  if (collection[0].hasOwnProperty('name')) {
    if (typeof collection[0].name !== 'string') {
      throw new TypeError(
        'Invalid value type passed for name of option ' +
          collection[0].name +
          '. Value should be string.'
      );
    }
  } else {
    throw new Error(collection[0] + 'does not contain name key.');
  }
}

/**
 * Validate the structure of the array
 * It must be formatted as list of values
 * @param {Array} collection Array of object (e.g. ['36', 'Black'])
 */
function _validateOptionsArray(options) {
  if (Array.isArray(options) && typeof options[0] === 'object') {
    throw new Error(options + 'is not a valid array of options.');
  }
}


/***/ }),

/***/ "./src/assets/js/product-form.js":
/*!***************************************!*\
  !*** ./src/assets/js/product-form.js ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _shopify_theme_product_form__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @shopify/theme-product-form */ "./node_modules/@shopify/theme-product-form/theme-product-form.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }


window.Shopify = window.Shopify || {};
window.Shopify.ProductForm = _shopify_theme_product_form__WEBPACK_IMPORTED_MODULE_0__.ProductForm;

(function () {
  if (!customElements.get('custom-dropdown')) {
    var CustomDropdown = /*#__PURE__*/function (_HTMLElement) {
      _inherits(CustomDropdown, _HTMLElement);

      var _super = _createSuper(CustomDropdown);

      function CustomDropdown() {
        var _this;

        _classCallCheck(this, CustomDropdown);

        _this = _super.call(this);
        _this.selectedEl = _this.querySelector('.selected-value');

        if (!_this.selectedEl) {
          return _possibleConstructorReturn(_this);
        }

        _this.button = _this.querySelector('button');

        _this.querySelectorAll('input').forEach(function (button) {
          return button.addEventListener('change', _this.onChange.bind(_assertThisInitialized(_this)));
        });

        _this.button.addEventListener('click', _this.onButtonClick.bind(_assertThisInitialized(_this)));

        window.addEventListener('click', function (event) {
          if (event.target.closest('button') == _this.button || event.target == _this.button) {
            return;
          }

          _this.querySelector('.selectDropdown').classList.remove('active');
        });
        return _this;
      }

      _createClass(CustomDropdown, [{
        key: "onChange",
        value: function onChange(event) {
          this.selectedEl.querySelector('span.value').innerHTML = event.currentTarget.value;

          if (event.currentTarget.dataset.color != 'transparent') {
            var new_bg = event.currentTarget.dataset.color;
            this.selectedEl.querySelector('span.circle').style.background = new_bg;
          }
        }

      }, {
        key: "onButtonClick",
        value: function onButtonClick(event) {
          this.querySelector('.selectDropdown').classList.toggle('active');
        }
      }]);

      return CustomDropdown;
    }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

    customElements.define('custom-dropdown', CustomDropdown);
  }

  if (!customElements.get('color-option')) {
    var ColorOption = /*#__PURE__*/function (_HTMLElement2) {
      _inherits(ColorOption, _HTMLElement2);

      var _super2 = _createSuper(ColorOption);

      function ColorOption() {
        var _this2;

        _classCallCheck(this, ColorOption);

        _this2 = _super2.call(this);
        _this2.selectedEl = _this2.querySelector('span.selected');

        if (!_this2.selectedEl) {
          return _possibleConstructorReturn(_this2);
        }

        _this2.querySelectorAll('input').forEach(function (button) {
          return button.addEventListener('change', _this2.onChange.bind(_assertThisInitialized(_this2)));
        });

        return _this2;
      }

      _createClass(ColorOption, [{
        key: "onChange",
        value: function onChange(event) {
          this.selectedEl.innerHTML = event.currentTarget.value;
        }
      }]);

      return ColorOption;
    }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

    customElements.define('color-option', ColorOption);
  }

  if (!customElements.get('product-form')) {
    customElements.define('product-form', /*#__PURE__*/function (_HTMLElement3) {
      _inherits(ProductForm, _HTMLElement3);

      var _super3 = _createSuper(ProductForm);

      function ProductForm() {
        var _this3;

        _classCallCheck(this, ProductForm);

        _this3 = _super3.call(this);
        _this3.productForm = null;
        _this3.main_product = _this3.hasAttribute('main-product');
        _this3.bundle_product = _this3.hasAttribute('bundle-product');
        _this3.form_type = _this3.dataset.type;
        _this3.form = _this3.querySelector('form');
        _this3.cart = document.querySelector('cart-drawer');
        _this3.submitButton = _this3.querySelector('[type="submit"]');

        if (_this3.querySelector('[data-price]')) {
          _this3.price = _this3.querySelector('[data-price]');
        }

        if (_this3.cart && _this3.submitButton) _this3.submitButton.setAttribute('aria-haspopup', 'dialog');
        var productHandle = _this3.form.dataset.productHandle;

        if (productHandle.trim() != '' && _this3.form_type != 'select') {
          fetch("/products/".concat(productHandle, ".js")).then(function (response) {
            return response.json();
          }).then(function (productJSON) {
            _this3.productForm = new _shopify_theme_product_form__WEBPACK_IMPORTED_MODULE_0__.ProductForm(_this3.form, productJSON, {
              onOptionChange: _this3.onOptionChange.bind(_assertThisInitialized(_this3)),
              onFormSubmit: _this3.onFormSubmit.bind(_assertThisInitialized(_this3))
            });
          });
        } else if (_this3.form_type == 'select') {
          console.log("select");

          _this3.form.addEventListener('change', _this3.onSelectFormSubmit.bind(_assertThisInitialized(_this3)));
        }

        _this3.loading = false; // if (this.form_type == 'select') {
        //   var select = this.querySelector('select[name="id"]');
        //   if (select) {
        //     select.addEventListener('change', ()=> {
        //       console.log("Change")
        //       if (select.value.trim() != '') {
        //         console.log("if")
        //         this.onFormSubmit.bind(this);
        //       }
        //     })
        //   }
        // }

        return _this3;
      }

      _createClass(ProductForm, [{
        key: "onFormSubmit",
        value: function onFormSubmit(event) {
          var _this4 = this;

          console.log("on form submit");

          if (this.loading) {
            return;
          }

          this.loading = true;
          event.preventDefault();
          var config = {
            method: 'POST',
            headers: {
              'Accept': 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest'
            }
          };
          var formData = new FormData(this.form);
          formData.append('sections', this.cart.getSectionsToRender().map(function (section) {
            return section.id;
          }));
          formData.append('sections_url', window.location.pathname);
          config.body = formData;

          if (this.submitButton) {
            this.submitButton.classList.add('loading');
          }

          fetch("".concat(routes.cart_add_url), config).then(function (response) {
            return response.json();
          }).then(function (response) {
            if (response.status) {
              alert(response.description);

              _this4.cart.open();

              return;
            }

            if (_this4.bundle_product && document.querySelector('[main-product]')) {
              _this4.mainProductForm = document.querySelector('[main-product] form');
              var _config = {
                method: 'POST',
                headers: {
                  'Accept': 'application/javascript',
                  'X-Requested-With': 'XMLHttpRequest'
                }
              };

              var _formData = new FormData(_this4.mainProductForm);

              _formData.append('sections', _this4.cart.getSectionsToRender().map(function (section) {
                return section.id;
              }));

              _formData.append('sections_url', window.location.pathname);

              _config.body = _formData;
              fetch("".concat(routes.cart_add_url), _config).then(function (response) {
                return response.json();
              }).then(function (response) {
                if (response.status) {
                  alert(response.description);

                  _this4.cart.open();

                  return;
                }

                _this4.cart.renderContents(response);
              })["catch"](function (e) {
                _this4.cart.open(); // console.error(e);

              })["finally"](function () {});
            } else {
              _this4.cart.renderContents(response);
            }
          })["catch"](function (e) {
            _this4.cart.open(); // console.error(e);

          })["finally"](function () {
            _this4.loading = false;

            if (_this4.submitButton) {
              _this4.submitButton.classList.remove('loading');
            }

            var select = _this4.querySelector('select[name="id"]');

            if (select) {
              select.value = '';
            }
          });
        }
      }, {
        key: "onSelectFormSubmit",
        value: function onSelectFormSubmit(event) {
          var _this5 = this;

          console.log(event); // this.form.querySelector('[name=id]').value = event.dataset.variant.id;

          if (this.loading) {
            return;
          }

          this.loading = true;
          event.preventDefault();
          var config = {
            method: 'POST',
            headers: {
              'Accept': 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest'
            }
          };
          var formData = new FormData(this.form);
          formData.append('sections', this.cart.getSectionsToRender().map(function (section) {
            return section.id;
          }));
          formData.append('sections_url', window.location.pathname);
          config.body = formData;

          if (this.submitButton) {
            this.submitButton.classList.add('loading');
          }

          fetch("".concat(routes.cart_add_url), config).then(function (response) {
            return response.json();
          }).then(function (response) {
            if (response.status) {
              alert(response.description);

              _this5.cart.open();

              return;
            }

            if (_this5.bundle_product && document.querySelector('[main-product]')) {
              _this5.mainProductForm = document.querySelector('[main-product] form');
              var _config2 = {
                method: 'POST',
                headers: {
                  'Accept': 'application/javascript',
                  'X-Requested-With': 'XMLHttpRequest'
                }
              };

              var _formData2 = new FormData(_this5.mainProductForm);

              _formData2.append('sections', _this5.cart.getSectionsToRender().map(function (section) {
                return section.id;
              }));

              _formData2.append('sections_url', window.location.pathname);

              _config2.body = _formData2;
              fetch("".concat(routes.cart_add_url), _config2).then(function (response) {
                return response.json();
              }).then(function (response) {
                if (response.status) {
                  alert(response.description);

                  _this5.cart.open();

                  return;
                }

                _this5.cart.renderContents(response);
              })["catch"](function (e) {
                _this5.cart.open(); // console.error(e);

              })["finally"](function () {});
            } else {
              _this5.cart.renderContents(response);
            }
          })["catch"](function (e) {
            _this5.cart.open(); // console.error(e);

          })["finally"](function () {
            _this5.loading = false;
            document.querySelector('.select-dropdown').classList.add('hidden');

            if (_this5.submitButton) {
              _this5.submitButton.classList.remove('loading');
            }

            var select = _this5.querySelector('select[name="id"]');

            if (select) {
              select.value = '';
            }
          });
        }
      }, {
        key: "onOptionSubmit",
        value: function onOptionSubmit(event) {
          var _this6 = this;

          if (this.loading) {
            return;
          }

          this.loading = true;
          var config = {
            method: 'POST',
            headers: {
              'Accept': 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest'
            }
          };
          var formData = new FormData(this.form);
          formData.append('sections', this.cart.getSectionsToRender().map(function (section) {
            return section.id;
          }));
          formData.append('sections_url', window.location.pathname);
          config.body = formData;
          fetch("".concat(routes.cart_add_url), config).then(function (response) {
            return response.json();
          }).then(function (response) {
            if (response.status) {
              alert(response.description);

              _this6.cart.open();

              return;
            }

            if (_this6.bundle_product && document.querySelector('[main-product]')) {
              _this6.mainProductForm = document.querySelector('[main-product] form');
              var _config3 = {
                method: 'POST',
                headers: {
                  'Accept': 'application/javascript',
                  'X-Requested-With': 'XMLHttpRequest'
                }
              };

              var _formData3 = new FormData(_this6.mainProductForm);

              _formData3.append('sections', _this6.cart.getSectionsToRender().map(function (section) {
                return section.id;
              }));

              _formData3.append('sections_url', window.location.pathname);

              _config3.body = _formData3;
              fetch("".concat(routes.cart_add_url), _config3).then(function (response) {
                return response.json();
              }).then(function (response) {
                if (response.status) {
                  alert(response.description);

                  _this6.cart.open();

                  return;
                }

                _this6.cart.renderContents(response);
              })["catch"](function (e) {
                _this6.cart.open(); // console.error(e);

              })["finally"](function () {});
            } else {
              _this6.cart.renderContents(response);
            }
          })["catch"](function (e) {
            _this6.cart.open(); // console.error(e);

          })["finally"](function () {
            _this6.loading = false;

            var select = _this6.querySelector('select[name="id"]');

            if (select) {
              select.value = '';
            }
          });
        }
      }, {
        key: "addedToCart",
        value: function addedToCart() {
          fetch("".concat(window.location.origin, "/cart.js")).then(function (res) {
            return res.clone().json().then(function (data) {
              var cart = {
                total_price: data.total_price / 100,
                $value: data.total_price / 100,
                total_discount: data.total_discount,
                original_total_price: data.original_total_price / 100,
                items: data.items
              };

              if (item !== 'undefined') {
                cart = Object.assign(cart, item);
              }
            });
          });
        }
      }, {
        key: "onOptionChange",
        value: function onOptionChange(event) {
          console.log("option change");
          var variant = event.dataset.variant;
          var buttonspan = this.submitButton.querySelector('span.btn-text');

          if (variant === null) {
            this.submitButton.disabled = false;

            if (buttonspan) {
              buttonspan.innerHTML = window.variantStrings.unavailable;
            }
          } else if (variant && !variant.available) {
            this.submitButton.disabled = true;

            if (buttonspan) {
              buttonspan.innerHTML = window.variantStrings.sold_out;
            }
          } else if (variant && variant.available) {
            this.submitButton.disabled = false;

            if (buttonspan) {
              buttonspan.innerHTML = window.variantStrings.add_to_cart;
            }
          }

          if (!variant) {
            return;
          }

          console.log("id");
          this.form.querySelector('[name=id]').value = variant.id;

          if (this.hasAttribute('main-product')) {
            console.log(variant.title);
            onColorChange(variant.title);
            var url = _shopify_theme_product_form__WEBPACK_IMPORTED_MODULE_0__.getUrlWithVariant(window.location.href, variant.id);
            window.history.replaceState({
              path: url
            }, '', url);
            fetch(window.location.href).then(function (response) {
              return response.text();
              refreshSlickSlider();
            }).then(function (html) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, 'text/html');
              document.querySelector('.price-wrapper').innerHTML = doc.querySelector('.price-wrapper').innerHTML;
              document.querySelector('.subscription__form').innerHTML = doc.querySelector('.subscription__form').innerHTML;
              document.querySelector('.addtocart-btn-sec').innerHTML = doc.querySelector('.addtocart-btn-sec').innerHTML;
            })["catch"](function (err) {
              console.warn('Something went wrong.', err);
            });
          }
        }
         
      }]);

      return ProductForm;
    }( /*#__PURE__*/_wrapNativeSuper(HTMLElement)));
  }
})(); // Function to initialize swiper

// cart-drawer slider
function refreshSlickSlider() {
  // Check if the Slick slider is initialized
  if ($('.upgrades-wrapper').hasClass('slick-initialized')) {
    // Unslick the slider to destroy the current instance
    $('.upgrades-wrapper').slick('unslick');
  }
  $('.upgrades-wrapper').slick({
    infinite: true,
    arrows: true,
    dots: false,
    slidesToScroll: 1,
    variableWidth: true,
    prevArrow: `<button type='button' class='slick-prev pull-left'><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none"><rect x="-0.5" y="0.5" width="35" height="35" rx="17.5" transform="matrix(-1 0 0 1 35 0)" fill="white"/><rect x="-0.5" y="0.5" width="35" height="35" rx="17.5" transform="matrix(-1 0 0 1 35 0)" stroke="black"/><path d="M20.25 25.5L12.75 18L20.25 10.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
    nextArrow: `<button type='button' class='slick-next pull-right'><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none"><rect x="0.5" y="0.5" width="35" height="35" rx="17.5" fill="white"/><rect x="0.5" y="0.5" width="35" height="35" rx="17.5" stroke="black"/><path d="M15.75 25.5L23.25 18L15.75 10.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`
  });
}
function refreshSliderWithDelay() {
  setTimeout(function() {
    refreshSlickSlider();
  }, 500); // Adjust the delay time as needed
}

$(document).ready(function() {
  refreshSliderWithDelay();
});
  
function initializeSwiper() {
  console.log('swiper init');
  var swiper = new Swiper(".mySwiper", {
    slidesPerView: 1,
    spaceBetween: 0,
  centeredSlides: false,
    freeMode: false,
    loop: false,
    watchSlidesProgress: true,
    navigation: {
        nextEl: ".swiper-button-next-featured",
        prevEl: ".swiper-button-prev-featured"
      },
    breakpoints: {
      100: {
        slidesPerView: 2,
        spaceBetween: 0
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 0
      },
      1024: {
        slidesPerView: 4.5,
        spaceBetween: 0
      }
    }
  });
  var swiper2 = new Swiper(".mySwiper2", {
    spaceBetween: 0,
  centeredSlides: false,
    loop: true,
    pagination: {
      el: ".swiper-pagination-pdp-gallery",
      clickable: true
    },
    thumbs: {
      swiper: swiper
    },
    on: {
      slideChange: function slideChange() {
        // console.log('slide changed');
        // console.log('Active slide index: ', this.activeIndex);
        if (document.querySelector('.pdp-variant .size-select-box select')) {
          document.querySelector('.product-banner-left').style.pointerEvents = 'none';
          document.querySelector('.product-banner-left').style.cursor = 'progress';
          var current_option = this.slides[this.activeIndex].getAttribute('data-slide');
          var option_selector = document.querySelector('.pdp-variant .size-select-box select');
          var optionExists = Array.from(option_selector.options).some(function (option) {
            return option.value === current_option.replace('#color_', '');
          });
          var option_select = current_option.replace('#color_', '');

          if (optionExists) {
            option_selector.value = option_select;

            if ("createEvent" in document) {
              var evt = document.createEvent("HTMLEvents");
              evt.initEvent("change", false, true);
              option_selector.dispatchEvent(evt);
            } else {
              option_selector.fireEvent("onchange");
            }
          }

          setTimeout(function () {
            document.querySelector('.product-banner-left').style.pointerEvents = 'all';
            document.querySelector('.product-banner-left').style.cursor = 'grab';
          }, 1000);
        }
      }
    }
  });
  swiper2.slideTo(0);
  swiper.slideTo(0);
}

function onColorChange(currentColor) {
  // console.log(currentColor, 'currentColor');
  var colorTag = "#color_" + currentColor.toLowerCase();
  console.log(colorTag, 'colorTag'); // Get the swiper slides

  var swiperSlides = document.querySelectorAll('.mySwiper2 .swiper-slide');
  var index = 0; // Loop over the slides and find the one with the matching data-slide value

  for (var i = 0; i < swiperSlides.length; i++) {
    if (swiperSlides[i].getAttribute('data-slide').toLowerCase() === colorTag) {
      index = i;
      break;
    }
  } // Scroll the swiper to the slide with the matching data-slide value


  document.querySelector('.mySwiper2').swiper.slideTo(index);
}

document.addEventListener('DOMContentLoaded', function () {
  initializeSwiper();

  if (document.querySelector('.pdp-variant') && window.location.href.includes('products') && document.querySelector('.pdp-variant .size-select-box select')) {
    var currentColor = document.querySelector('.pdp-variant .default--options').value.trim();
    currentColor.toLowerCase();
    onColorChange(currentColor);
  }
});

/***/ }),

/***/ "./src/assets/scss/theme.scss":
/*!************************************!*\
  !*** ./src/assets/scss/theme.scss ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/product-banner.scss":
/*!*********************************************!*\
  !*** ./src/assets/scss/product-banner.scss ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/scss/blog-details.scss":
/*!*******************************************!*\
  !*** ./src/assets/scss/blog-details.scss ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/theme/assets/product-form": 0,
/******/ 			"theme/assets/blog-details": 0,
/******/ 			"theme/assets/product-banner": 0,
/******/ 			"theme/assets/theme": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkydm_starter_theme"] = self["webpackChunkydm_starter_theme"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["theme/assets/blog-details","theme/assets/product-banner","theme/assets/theme"], () => (__webpack_require__("./src/assets/js/product-form.js")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/blog-details","theme/assets/product-banner","theme/assets/theme"], () => (__webpack_require__("./src/assets/scss/theme.scss")))
/******/ 	__webpack_require__.O(undefined, ["theme/assets/blog-details","theme/assets/product-banner","theme/assets/theme"], () => (__webpack_require__("./src/assets/scss/product-banner.scss")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["theme/assets/blog-details","theme/assets/product-banner","theme/assets/theme"], () => (__webpack_require__("./src/assets/scss/blog-details.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;